
export const environment = {
    production: false,
    apiUrl: 'https://golfai.dev/api/',
    webUrl: 'https://golfai.dev',
    mapBoxApiKey:'pk.eyJ1IjoicGV0ZXJiZXJnaW4iLCJhIjoiY20xbGx1bjh0MGF5azJxb2w2ZzJqMHQ3NiJ9.k8nlZCg5SDET2xiOL_kE-A',
    liveKitUrl: 'wss://main-6056lcja.livekit.cloud/',
    appStoreUrl: 'https://apps.apple.com/app/idYOUR_APP_ID',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=YOUR_PACKAGE_NAME'
  };
  